import { Component } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Registry } from '@/registry.service';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { RentalAgencyModel } from '@/models/tables/rental-agency.model';
import { DialogBankAccountComponent } from '@pages/tables/bank-account/dialog-bank-account/dialog-bank-account.component';

@Component({
  selector: 'app-button-new-bank-account',
  templateUrl: '../../button.component.html',
  styleUrls: ['../../button.component.scss'],
})
export class ButtonNewBankAccountComponent extends ButtonComponent {
  private dialogOpened: MatDialogRef<any>;
  faIcon = faPenToSquare;

  constructor(
    protected router: Router,
    protected toastr: ToastrService,
    private dialog: MatDialog,
  ) {
    super(router, toastr);

    this.showIcon = false;
    this.additionalClass = 'ml-2';
    this.content = 'Nuova Banca';
  }

  /**
   * Open modal new detail page
   */
  public actionClick(): void {
    this.dialogOpened = this.dialog.open(DialogBankAccountComponent, {
      data: new RentalAgencyModel(),
    });

    Registry.getInstance().set('DialogBankAccountComponentNew', this.dialogOpened);
  }
}
